<template>
  <div>
    <table style="width:100%;">
      <tr v-for="(item, i) in tableData" :key="i">
        <td bgcolor="#eef1f6" class="right">
          <p class="mr-15 mb-0">{{ item.lable1 }}</p>
        </td>
        <td class="left">
          <p class="ml-15 mb-0">{{ item.value1 }}</p>
        </td>
        <td bgcolor="#eef1f6" class="right">
          <p class="mr-15 mb-0">{{ item.lable2 }}</p>
        </td>
        <td class="left">
          <p class="ml-15 mb-0">{{ item.value2 }}</p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ['tableData'],
  data() {
    return {}
  },
  mounted() { },
  methods: {}
}
</script>
<style lang="less" scoped>
table,
table tr th,
table tr td {
  border: 1px solid #dae6fc;
  line-height: 40px;
}

.mb-0 {
  margin-bottom: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.left {
  width: 33.4%;
  color: #999;

  p {
    line-height: 19px;
  }
}

.right {
  width: 16.6%;
  text-align: right;
}
</style>
